module.exports = __webpack_public_path__ + "img/gmail_imagotype.35ab2f6f.png";